import React, { Component } from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Modal from 'react-modal';
import _actions from '../../actions';
import ProjectTitle from '../projects/ProjectTitle';
import PublishArrow from '../svg/Publish';
import Eye from '../svg/preview/Eye';
import Spinner from '../svg/Spinner';
import Ban from '../svg/Ban';
import SuccessCheck from '../svg/SuccessCheck';
import PublishPopover from './PublishPopover';

class VersionHeader extends Component {
    constructor(props) {
        super(props);
        this.togglePreview = this.togglePreview.bind(this);
        this.updateTitle = this.updateTitle.bind(this);
        this.publishProject = this.publishProject.bind(this);
        this.showPublishPopover = this.showPublishPopover.bind(this);
        this.state = { publishPopoverVisible: false };
    }

    togglePreview() {
        if (this.props.togglePreview) {
            this.props.togglePreview();
        }
    }

    updateTitle(versionName) {
        this.props.actions.updateProjectVersionbyParameter(
            this.props.versions.select.projectId,
            'name',
            versionName,
        );
    }

    showPublishPopover() {
        this.setState((prevState) => {
            return { publishPopoverVisible: !prevState.publishPopoverVisible };
        });
    }

    publishProject() {
        if (this.props.loadingBar === 0) {
            this.props.actions.publishProject(
                this.props.projects.selected.id, this.props.profiles.data.givingChurchId,
            );
        }
    }

    render() {
        let {
            name,
            versionNumber,
            saving,
            justSaved,
        } = this.props;
        if (typeof (name) === 'undefined') {
            name = '';
        }
        if (typeof (versionNumber) === 'undefined') {
            versionNumber = '';
        }

        let savingMessage = '';
        if (saving) {
            savingMessage = (<span className="saving">Saving...</span>);
        } else if (justSaved) {
            savingMessage = (<span className="saving">Saved Successfully!</span>);
        }
        let publishable = true;
        if (this.props.proj_conf?.data?.length > 0) {
            publishable = false;
        }
        const isTrial = localStorage.getItem('IsTrial');
        return (
            <div>
                <div className="secondary-nav-app">
                    <div className="secondary-nav__info-wrap">
                        <div className="app-info">
                            <div id="app-info-wrapper" className="app-info-wrap">
                                <h2 id="app-title" className="app-title">
                                    <ProjectTitle
                                        id="edit-project-name"
                                        version={this.props.versions.select}
                                        updateTitle={this.updateTitle}
                                        name={name}
                                    />
                                </h2>
                                <h3 id="app-version" className="app-version">{`v${versionNumber}`}</h3>
                            </div>
                        </div>
                        <div className="app-save-status">
                            {savingMessage}
                        </div>
                    </div>
                    <Modal
                        isOpen={this.props.versions.publishProgress}
                        style={{ content: { background: 'rgba(255,255,255,.35)' } }}
                    />
                    <div className="secondary-nav__actions">
                        <ul className={`actions ${this.props.loadingBar === 0 ? '' : 'loading'}`}>
                            {this.props.versions.publishProgress
                            && (
                                <li className="publish enabled spin">
                                    <Spinner />
                                </li>
                            )}
                            {this.props.projects.justPublished
                            && (
                                <li className="publish published">
                                    <SuccessCheck />
                                </li>
                            )}
                            {this.props.projects.selected
                            && this.props.projects.selected.liveVersion
                            && !this.props.publish.updatedNew
                            && !this.props.projects.justPublished
                            && !this.props.versions.publishProgress
                            && (
                                isTrial ?
                                <li className="publish no-changes">
                                    <span>Publish</span>
                                    <Ban />
                                </li>
                                :
                                <li className="publish no-changes">
                                    <span>Publish</span>
                                    <PublishArrow />
                                </li>
                            )}
                            {this.props.projects.selected
                            && this.props.projects.selected.liveVersion
                            && this.props.publish.updatedNew && publishable
                            && !this.props.projects.justPublished
                            && !this.props.versions.publishProgress
                            && (
                                // eslint-disable-next-line
                                isTrial ?
                                <li className="publish no-changes">
                                    <span>Publish</span>
                                    <Ban />
                                </li>
                                :
                                <li className="publish enabled" onClick={this.publishProject}>
                                    <span>Publish</span>
                                    <PublishArrow />
                                </li>
                            )}
                            {this.props.projects.selected
                            && this.props.projects.selected.liveVersion
                            && this.props.publish.updatedNew && !publishable
                            && !this.props.projects.justPublished
                            && !this.props.versions.publishProgress
                            && (
                                // eslint-disable-next-line
                                isTrial ?
                                <li className="publish no-changes">
                                    <span>Publish</span>
                                    <Ban />
                                </li>
                                :
                                <li className="publish disabled" onClick={this.showPublishPopover}>
                                    <span>Publish</span>
                                    <Ban />
                                </li>
                            )}
                            <li className="preview">
                                {this.props.versions.showPreview
                                && (
                                    // eslint-disable-next-line
                                    <a
                                        id="preview-launcher"
                                        className="active"
                                        onClick={this.togglePreview}
                                    >
                                        <Eye />
                                    </a>
                                )}
                            </li>
                        </ul>
                    </div>
                </div>
                {this.props.projects.selected
                && this.props.projects.selected.liveVersion
                && this.props.proj_conf?.data?.length > 0
                && (
                    <PublishPopover
                        projectId={this.props.versions.select.projectId}
                        CloseDialog={this.showPublishPopover}
                        Errors={this.props.proj_conf.data}
                        Visible={this.state.publishPopoverVisible}
                        pagesFlag={this.props.flags.results?.customContentPages}
                    />
                )}
            </div>

        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(VersionHeader);
